export function sortDetailStatisticsChartData(source, columns) {
  return new Promise((resolve) => {
    const detailData = {
      campaignId: source?.id,
      detailPeriod: source?.detailPeriod,
      series: [] as Array<any>,
    };

    if (source !== null && source.data?.length) {
      const collection = new Set() as any;

      source.data.forEach((s) =>
        Object.keys(s.campaigns[0]).forEach((key) => {
          collection.add(key);
        })
      );

      collection.forEach((key, valueAgain, coll) => {
        const name = columns.find((c) => c.field === key)?.name;
        if (name) {
          coll[key] = {
            name,
            data: [],
          };
        }
      });

      let value: any;
      source.data.forEach((s) => {
        collection.forEach((key, valueAgain, coll) => {
          const period = +new Date(s.period);

          value = s.campaigns[0][key];
          if (typeof value !== 'number') {
            value = 0;
          }
          coll[key].data.push([period, value]);
        });
      });

      if (collection.size) {
        detailData.series = Object.values(
          JSON.parse(JSON.stringify(collection))
        );
      }
    }

    resolve(detailData);
  });
}
